/**
 * Fatura kalemi tiplerinin renkleri.
 *
 * IKI yerde kullaniliyor: kalem tablosundaki rozetlerde (kalemtablosu.vue) ve
 * satir penceresindeki "tipe gore dagilim" seridinde
 * (dismuhasebeaktarim.vue). Ayri modul olmasinin sebebi bu - iki yere
 * kopyalansaydi seritteki renk ile tablodaki rozet birbirini tutmaz, gorsel
 * eslesme de anlamini yitirirdi.
 *
 * Anahtar MuhasebeEntegrasyon.Core.Model.SatirTipi enum'unun sayisal
 * degeridir.
 */
const RENKLER = {
  0: "blue darken-1", // Bilet bedeli
  1: "deep-orange darken-1", // Vergi / harc
  2: "teal darken-1", // Servis ucreti
  3: "cyan darken-2", // Diger servis
  4: "red darken-2", // Iskonto
  5: "purple darken-1", // Ek saha
  6: "brown darken-1", // KDV masrafi
  7: "indigo darken-1", // Ozel islem
  8: "pink darken-2", // Ceza / iptal
  9: "amber darken-4", // Alan vergisi (maliyette ayri kalem)
};

/**
 * Kalem tipinin Vuetify renk sinifi.
 *
 * Tanimsiz bir tip gelirse gri donulur: enum'a yeni bir kalem eklendiginde
 * ekran renksiz kalir ama patlamaz.
 */
export function TipRengi(tip) {
  return RENKLER[tip] || "grey darken-1";
}

export default { TipRengi };
